var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_16744)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91675 15.084C3.91675 15.6896 4.35987 16.084 4.79175 16.084H6.91675L6.91675 3.58398L4.79175 3.58398C4.35987 3.58398 3.91675 3.97839 3.91675 4.58398L3.91675 15.084ZM14.5417 16.084H12.6667V12.834H15.4167V15.084C15.4167 15.6896 14.9736 16.084 14.5417 16.084ZM11.1667 12.834V16.084H8.41675V12.834H11.1667ZM15.4167 11.334H12.6667V8.16748H15.4167V11.334ZM15.4167 6.66748H12.6667V3.58398L14.5417 3.58398C14.9736 3.58398 15.4167 3.97839 15.4167 4.58398V6.66748ZM11.1667 6.66748V3.58398L8.41675 3.58398V6.66748H11.1667ZM8.41675 8.16748V11.334H11.1667V8.16748H8.41675ZM4.79175 17.584C3.4287 17.584 2.41675 16.4114 2.41675 15.084V4.58398C2.41675 3.25658 3.4287 2.08398 4.79175 2.08398H14.5417C15.9048 2.08398 16.9167 3.25658 16.9167 4.58398V15.084C16.9167 16.4114 15.9048 17.584 14.5417 17.584L4.79175 17.584Z",
    fill: "#2B2B35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_16744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderColumn);
export default __webpack_public_path__ + "static/media/header_column.7cb6ff498731e939928b4ddacb6cd2c5.svg";
export { ForwardRef as ReactComponent };